import { render } from "./BpaSizer.vue?vue&type=template&id=49638fc2"
import script from "./BpaSizer.vue?vue&type=script&lang=js"
export * from "./BpaSizer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__